import * as React from 'react';
import { cn } from '@hqo/react-hooks';
import { Button } from '@hqo/ui-atoms';
import { TriangleAlert } from 'lucide-react';

interface ErrorNotificationProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description: string;
  buttonText?: string;
  onClick?: () => void;
}

export const ErrorNotification = ({ className, title, description, buttonText, onClick }: ErrorNotificationProps) => (
  <div
    className={cn(
      'flex flex-col items-center text-center space-y-4',
      className,
    )}
    data-testid="error-notification"
  >
    <TriangleAlert className="h-12 w-12 text-system-grey-dark" />
    <div className="space-y-2">
      <h3 className="text-lg font-semibold text-system-black">{title}</h3>
      <p className="text-sm text-system-grey-dark">{description}</p>
    </div>
    {buttonText && onClick && (
      <Button
        onClick={onClick}
        className="mt-4"
        data-testid="error-notification-button"
      >
        {buttonText}
      </Button>
    )}
  </div>
);
